import { AppConfig, awsConfiguration } from '@/aws-configuration';
import { Auth } from '@aws-amplify/auth';
/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
import axios, { AxiosInstance } from 'axios';

export class FlightPathAxios {
  apiVersion: string;
  authToken: string;
  localMode: boolean;
  flightPathIp: string;
  version: string;

  constructor() {
    this.apiVersion = 'api-v2';
    this.authToken = '';
    this.localMode = false;
    this.flightPathIp = '';

    //todo move this into vuex
    if (localStorage.localMode) {
      this.localMode = localStorage.localMode == 'true';
    }
    this.version = awsConfiguration.apiVersion;
    if (!this.localMode) {
      this.apiVersion = this.version;
    }

    if (localStorage.flightPathIp) {
      this.flightPathIp = localStorage.flightPathIp;
      this.flightPathIp += `/${this.apiVersion}`;
    } else {
      this.flightPathIp = 'http://localhost:3580';
      this.flightPathIp += `/${this.apiVersion}`;
    }

    switch (this.version) {
      case 'Beta':
        this.flightPathIp = AppConfig.Beta;
        break;
      case 'Prod':
        this.flightPathIp = AppConfig.Prod;
        break;
      case 'RC':
        this.flightPathIp = AppConfig.RC;
        break;
      default:
        break;
    }
  }

  getInstance(): AxiosInstance {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    const instance = axios.create({
      baseURL: `${this.flightPathIp}`,
      withCredentials: false,
      headers: headers
    });
    if (this.localMode == false) {
      instance.interceptors.request.use(async config => {
        const session = await Auth.currentSession();
        const jwtToken = session.getIdToken().getJwtToken();

        return {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${jwtToken}`
          }
        };
      });
    }

    return instance;
  }
}
